import { ReactNode } from "react";
import AdminLayout from "../shared/AdminLayout";
import { useIntl, FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { usAdminAppRoutes } from "../../../route-definitions";
import BaseFilters from "../shared/components/BaseFilters";
import { getVendorFilters } from "./services/vendor-service";
import { getMainFilterOptions } from "./vendor.constants";
import { ButtonConfig } from "../shared/components/HeaderButtons";
import BaseFilterChip from "../shared/components/FilterChip";
import { FilterOption } from "../shared/components/BaseFilters";
import HeaderSearchInput from "../shared/components/HeaderSearch";

interface Props {
  children: ReactNode;
  searchInput: string;
  onSearchInputChange: (value: string) => void;
  onFilterChange: (
    mainFilter: FilterOption | null,
    subcategory: FilterOption | null
  ) => void;
  appliedFilters: Record<string, string>;
  onRemoveFilter: (filterKey: string) => void;
}

function VendorPageLayout({
  children,
  searchInput,
  onSearchInputChange,
  onFilterChange,
  appliedFilters,
  onRemoveFilter,
}: Props) {
  const intl = useIntl();
  const history = useHistory();

  function handleButtonClick() {
    history.push(usAdminAppRoutes.createVendor);
  }

  const headerButtons: ButtonConfig[] = [
    {
      id: "add-vendor-button",
      text: intl.formatMessage({ id: "usAdmin.addVendor" }),
      backgroundColor: "green",
      handleClick: handleButtonClick,
      className: "",
    },
  ];

  const mainFilterOptions = getMainFilterOptions(intl);

  return (
    <AdminLayout
      header={<FormattedMessage id="usAdmin.vendor" />}
      headerButtons={headerButtons}
      headerActions={
        <div className="usadmin-admin-layout">
          <div className="usadmin-header-actions">
            <HeaderSearchInput
              searchInput={searchInput}
              onSearchInputChange={onSearchInputChange}
              placeholder={intl.formatMessage({
                id: "usAdmin.searchByAllFields",
              })}
            />
            <BaseFilters
              onFilterChange={onFilterChange}
              onRemoveFilter={onRemoveFilter}
              mainFilterOptions={mainFilterOptions}
              fetchOptions={getVendorFilters}
              filterLabel={intl.formatMessage({ id: "usAdmin.filter" })}
              selectCategoryPlaceholder={intl.formatMessage({
                id: "usAdmin.selectCategory",
              })}
            />
          </div>
          <BaseFilterChip
            appliedFilters={appliedFilters}
            onRemoveFilter={onRemoveFilter}
            mainFilterOptions={mainFilterOptions}
          />
        </div>
      }
      containerClassName="usadmin-entities-main-container"
    >
      {children}
    </AdminLayout>
  );
}

export default VendorPageLayout;
